import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router ,ActivatedRoute} from '@angular/router';
import {
  Inputparameterlist,
  ParamaterListResult,
  trxInquiryBody,
  trxInquiryResponse,
  Bill_BillerService,
  Service,
  eagerLoadedBillBillerService,
} from '../../interfaces/biller-interfaces';
import { BaseForm } from 'src/app/shared/product/baseForm';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { Validators } from 'src/app/shared/validators';
import { FormField } from 'src/app/dashboard/admin/report/report';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { selectedServiceNotifierService } from '../selectedServiceNotifer.service';
import { InquireTransactionService } from '../../shared/services/InquireTransaction.service';
import { InputParameterListService } from '../../shared/services/inputParamaterList.service';
import { prepareNonInquireTransaction } from '../../shared/services/prepareNonInquireTransaction.service';
import { isInquirableService } from '../../shared/services/isInquirable.service';
import { AirChargeService } from '../../shared/services/airCharge.service';
import { TranslateService } from '@ngx-translate/core';
import { GetPriceDetailsService } from '../../shared/services/GetPriceDetails.service';

const WE_TOP_UP_SERVICE_ID = 626237;

@Component({
  selector: 'app-service-form',
  templateUrl: './service-form.component.html',
  styleUrls: ['./service-form.component.scss'],
})
export class ServiceFormComponent extends BaseForm implements OnInit {
  billerService: Bill_BillerService;
  service: Service;
  providerId;
  BillerServiceForm: FormGroup;
  billerServiceResult: ParamaterListResult;
  providerServices: billAndService[] = [];
  formValidator;
  isInquirable = true;
  success = false;
  errMsg = null;
  ObjectKeys = [];
  trxInquiryResponse: trxInquiryResponse;
  res: any;
  provID: number;
  payMethod: string;
  amount: number;
  totalAmount : number;
  isAircharge : boolean = false
  priceTypeList: boolean = false;
  priceList: number[] = [];
  selectPrice: number;
  config = {
      search: false,
      height: '200px',
      displayKey: 'Amount',
  }
  amountFormField!: FormField;

  constructor(
    private router: Router,
    private route :ActivatedRoute,
    private serviceNotifier: selectedServiceNotifierService,
    private inquireTransaction: InquireTransactionService,
    private getInputParamListServ: InputParameterListService,
    private prepareNonInq: prepareNonInquireTransaction,
    private inqService: isInquirableService,
    private airchargeService : AirChargeService,
    private translate: TranslateService,
    private getPriceDetailsService: GetPriceDetailsService
  ) {
    super();
    this.formValidator = new FormValidatorService();
  // route to selected category if no res
    if (!this.router.getCurrentNavigation()?.extras?.state) {
      let catId : number
      this.route.parent.paramMap.subscribe(params=>{
        catId = +params.get('categoryId')
      })
      this.router.navigate([`seller/billPayments/category/${catId}`]);
    }
    this.res = this.router.getCurrentNavigation().extras.state;
    // derect provider id change onclick provider
    this.route.paramMap.subscribe(params=>{
      this.provID = +params.get('providerId')
      this.ngOnInit();
    })
  }
  controllers: { [key: string]: FormField } = {};
  async ngOnInit() {
    try {
    this.translate.use(localStorage.getItem("language"));
      if (this.res) {
        this.handleProviderServicesDisplay(this.res);
      }
      this.serviceNotifier
        .getbillProviderAndServices()
        .subscribe(async (res) => {
          if (res.length) {
            this.handleProviderServicesDisplay(res);
          }
        });
        if(this.providerServices.length===1){
          let serv = this.providerServices[0]
          this.displayBillerServiceForm(serv)
        }
        this.isAircharge = this.airchargeService.isAirchargeService(this.service.name)
    } catch (err) {
      console.log(err);
    }
  }
  handleProviderServicesDisplay(res: eagerLoadedBillBillerService[]) {
    this.service = null;
    this.BillerServiceForm = null;
    this.amount =null;
    this.totalAmount = null;
    this.providerServices = res
      .filter((res) => {
        return res.ProviderID == this.provID;
      })
      .map((res) => {
        return {
          billServ: res,
          Service: res.Service,
        };
      });
  }
  async displayBillerServiceForm(res: billAndService) {
    try {
      this.success= false;
      this.BillerServiceForm = null;
      this.totalAmount=null
      this.service = res.Service;
      this.isInquirable = res.billServ.isInquirable;
      this.inqService.setState(this.isInquirable);
      this.getInputParamListServ.setParams({
        billerService: res.billServ.Bill_Service_ID,
      });
      this.billerServiceResult = await this.getInputParamListServ.make();

      this.getPriceDetailsService.setPath(
        res.billServ.Bill_Service_ID.toString()
      );

      const priceRes = await this.getPriceDetailsService.make();
      const priceData = priceRes.data;
      console.log("priceData -> ", priceData);


      const paramList = this.billerServiceResult.data.input_parameter_list.sort(
        (a, b) => a.position - b.position
      );

      this.controllers = {};
      this.ObjectKeys = [];
      this.billerService = res.billServ;

        for (let param of paramList) {
          const formField: FormField = {
            fieldName: param.name,
            defaultValue: param.default_value || null,
          };
          formField.validators = [
            {
              validatorFn: Validators.minLength(param.min_length),
              message: `${this.validationMsg.minLength} ${param.min_length} `,
            },
            {
              validatorFn: Validators.maxLength(param.max_length),
              message: `${this.validationMsg.maxLength} ${param.max_length} `,
            },
            param.required
              ? {
                  validatorFn: Validators.required,
                  message: `${this.validationMsg.required}`,
                }
              : null,
          ];
          this.controllers[param.key] = formField;
          this.ObjectKeys.push(param.key);


          if (param.confirm_required) {
            const confirmFieldName = `Confirm ${param.name}`;
            const confirmField: FormField = {
              ...formField,
              fieldName: `${confirmFieldName}`,
            };
            confirmField.validators = [
              {
                validatorFn: CustomValidators.confirmPasswordWith(param.name),
                message: `${confirmFieldName} not match ${param.name}`,
              },
            ];
            this.controllers[`Confirm ${param.name}`] = confirmField;
            this.ObjectKeys.push(confirmFieldName);
          }
        }

        const trxIsNoneInquirable = !this.isInquirable;

        if (trxIsNoneInquirable) {
          const priceIsFixed = priceData.type === 'FIXED';
          const priceIsRange = priceData.type === 'RANGE';
          let defaultValue = 0;

          if(priceIsFixed) {
            defaultValue = priceData.service_value;
          }

          if (priceIsRange || priceIsFixed) {
            this.amountFormField = {
              fieldName: 'Amount',
              defaultValue: defaultValue,
              disabled: priceIsFixed
            };

            const minValue = priceIsRange? priceData.min_value : priceData.service_value;
            const maxValue = priceIsRange? priceData.max_value : priceData.service_value;

            this.amountFormField.validators = [
              {
                validatorFn: Validators.min(minValue),
                message: `${this.validationMsg.minLength} ${minValue} `,
              },
              {
                validatorFn: Validators.max(maxValue),
                message: `${this.validationMsg.maxLength} ${maxValue} `,
              },
              {
                validatorFn: Validators.required,
                message: `${this.validationMsg.required}`,
              },
            ];

            this.priceTypeList = false;
            this.amount = defaultValue ? defaultValue : null;
          } else if (priceData.type === 'LIST') {
            this.priceTypeList = true;
            this.priceList = priceData.value_list;
          }
        }

        let ele = document.getElementById(res.Service.name);
        localStorage.setItem('oldElement', res.Service.name);
        ele.classList.add('active');

        this.BillerServiceForm = this.formValidator.createForm(
          Object.values(this.controllers)
        );
    } catch (err) {
      console.log(err);
    }
  }
  convertControls(key: string) {
    const name = this.controllers[key].fieldName;
    return this.BillerServiceForm.get(name) as FormControl;
  }
  handleAmount(e: any) {
    this.success = false;
    const inputValue = e.target.value;
    if(inputValue <= 0||!inputValue||isNaN(inputValue)){
        this.success = false
        this.amount = null
        this.totalAmount=null
        this.errMsg = 'invalid amount'
    }else{
      this.amount = inputValue;
     this.totalAmount= this.airchargeService.calculateTotalAmount(this.amount,this.service.name)
      this.errMsg =''
    }

  }
  async handleNonInquirable() {
    const amount = this.amount;
    const trxBody = this.transactionBillObject();
    const nonInqParams = {
      amount,
      billerService: trxBody.billerService,
      input_parameter_list: trxBody.input_parameter_list,
      userRole : 'Seller'
    };
    try {
      this.prepareNonInq.setParams(nonInqParams);
      const result = await this.prepareNonInq.make();
      this.prepareNonInq.setResponse(result);
      this.prepareNonInq.setTotalAmount(this.totalAmount)
      this.success = true;
    } catch (err) {
      const faultyRequesterror = err?.faultyRequest?.error;
      if (faultyRequesterror) {
        this.errMsg = faultyRequesterror.message;
        setTimeout(() => {
          this.errMsg = null;
        }, 8000);
      }
    }
  }

  transactionBillObject() {
    let inputParamaterList: Inputparameterlist[] = [];
    for (const [key] of Object.entries(this.controllers)) {
      if (key.startsWith('Confirm')) continue;
      const keyValue = this.convertControls(key).value
      if(!keyValue) continue;
      inputParamaterList.push({
        key: key,
        value: keyValue,
      });
    }
    let trxIqrBody: trxInquiryBody = {
      billerService: this.billerService.Bill_Service_ID,
      input_parameter_list: inputParamaterList,
      userRole : 'Seller'
    };
    return trxIqrBody;
  }
  async submit() {
    try {
      this.errMsg = null;
      const trxIqrBody = this.transactionBillObject();
      this.inquireTransaction.setParams(trxIqrBody);
      this.trxInquiryResponse = await this.inquireTransaction.make();
      this.success = this.trxInquiryResponse.success;
      if (this.success) {
		  /* WARN: We Top Up service the amount return as rang type but it list
		  * return in the data.info_text as text if thery any service have the
		  * same issue it while handle defferent
		  * */
		  if (this.billerService.Bill_Service_ID == WE_TOP_UP_SERVICE_ID) {
			  const list = this.trxInquiryResponse.data.info_text
			  .replace(/\s+/g, '')
			  .match(/\d+.\d+(EGP)/g)
			  .map((n) => parseFloat(n));
			  this.priceTypeList = true;
			  this.priceList = list;
			  this.selectPrice = list[0]
		  }
      }
    } catch (err) {
      console.log(err);
      const faultyRequesterror = err?.faultyRequest?.error;
      if (faultyRequesterror) {
        this.errMsg = faultyRequesterror.message;
        setTimeout(() => {
          this.errMsg = null;
        }, 8000);
      }
    }
  }
  isFulLWidthLastController(index) {
    if (this.ObjectKeys.length % 2 == 0) {
      return false;
    }

    if (this.ObjectKeys.length - 1 == index) {
      return true;
    } else return false;
  }
  isServiceChanged(result: Service) {
    if (this.service == null) {
      return true;
    }
    if (this.service.billerService == result.billerService) {
      if (this.service.providerId == result.providerId) {
        return false;
      }
    }
    return true;
  }
  handlePayChange(e: any) {
    this.payMethod = e.target.value;
  }
  async ProceedToPay() {
    if (this.payMethod === 'Credit') {
      this.router.navigate(['seller/billPayments/credit-card']);
    }
    if (this.payMethod === 'Balance') {
      this.router.navigate(['seller/billPayments/balance-pay']);
    }
	if (this.priceTypeList) {
		this.trxInquiryResponse.data.amount = this.selectPrice;
	}
	this.inquireTransaction.setTrxResponse(this.trxInquiryResponse);
  }

  onSelectPrice(event: any) {
	  this.selectPrice = event.target.value;
  }

  activeButton(res: billAndService) {
    let oldElement = localStorage.getItem('oldElement');
    if (oldElement != null) {
      if (oldElement !== res.Service.name) {
        let oldEle = document.getElementById(oldElement);
        if (oldEle != null) oldEle.classList.remove('active');
      }
    }
    let ele = document.getElementById(res.Service.name);
    localStorage.setItem('oldElement', res.Service.name);
    ele.classList.add('active');
  }
}
interface billAndService {
  billServ: Bill_BillerService;
  Service: Service;
}
